export const TYPE = '@type';
export const STARTED = 'STARTED';
export const SUCCEEDED = 'SUCCEEDED';